import React from "react";
import {
  Typography,
  List,
  Grid,
  ListItem,
  ListItemText,
  Box,
  Dialog,
  IconButton,
  DialogContent,
  Divider,
} from "@mui/material";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";


function ModalInfoTanque(props) {
   const { datos, open, handleClose } = props;

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: 4,
            boxShadow: 8,
            overflow: "hidden",
          },
        }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Grid container backgroundColor="#1F618D" p={1.5}>
            <Grid item xs={2}>
              <IconButton onClick={() => handleClose()} sx={{ color: "#fff" }}>
                <ArrowBackIcon />
              </IconButton>
            </Grid>

            <Grid
              item
              xs={8}
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Typography variant="h5" color="#ffffff">
                Tanque/s a Instalar
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <DialogContent
          sx={{
            backgroundColor: "#f9fafb",
            borderRadius: 2,
            p: 3,
          }}
        >
          {/* Tanques */}
          <Box
            display="flex"
            justifyContent="space-around"
            alignItems="center"
            flexWrap="wrap"
            sx={{
              bgcolor: "white",
              borderRadius: 3,
              p: 2,
              mb: 3,
              boxShadow: 2,
            }}
          >
            {[
              { label: "0.5m³", value: datos.canttk_05 },
              { label: "1m³", value: datos.canttk_1 },
              { label: "2m³", value: datos.canttk_2 },
              { label: "4m³", value: datos.canttk_4 },
              { label: "7m³", value: datos.canttk_7 },
            ].map((item, index) => (
              <Box key={index} textAlign="center" mx={1} minWidth={80}>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  sx={{ color: "#4085afff" }}
                >
                  {item.label}
                </Typography>
                <Typography variant="h6">
                  {item.value ? item.value : 0}
                </Typography>
              </Box>
            ))}
          </Box>

          {/* Info Cliente */}
          <List
            sx={{
              bgcolor: "white",
              borderRadius: 3,
              boxShadow: 2,
            }}
          >
            <ListItem>
              <ListItemText
                primary={
                  <Typography
                    fontWeight="bold"
                    sx={{ color: "#4085afff", textDecoration: "underline" }}
                  >
                    Ubicación del cliente
                  </Typography>
                }
                secondary={
                  <Typography variant="body1">
                    {datos.direccion_factibilidad || "Sin datos"}
                  </Typography>
                }
              />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemText
                primary={
                  <Typography
                    fontWeight="bold"
                    sx={{ color: "#4085afff", textDecoration: "underline" }}
                  >
                    Nombre del comercial
                  </Typography>
                }
                secondary={
                  <Typography variant="body1">
                    {datos.comercial || "No especificado"}
                  </Typography>
                }
              />
            </ListItem>
          </List>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default ModalInfoTanque;
